import React from "react";
import * as S from "./styles";
import { getTranslateByKey } from "@/main/services/utils";
import WarningIcon from "@mui/icons-material/Warning";

interface ICardInfoProps {
	headerContent: React.ReactNode;
	bodyContent: React.ReactNode;
	isRequoteNational?: boolean;
}
function CardInfo({ headerContent, bodyContent, isRequoteNational }: ICardInfoProps) {
	return (
		<S.Container>
			<S.HeaderCard>
				<S.HeaderTitle>{headerContent}</S.HeaderTitle>
				<S.HeaderWarning>
					{isRequoteNational ? <WarningIcon style={{ color: "#fab01c" }} /> : ""}
					{isRequoteNational ? getTranslateByKey("information.nationalRequoteWarning") : ""}
				</S.HeaderWarning>
			</S.HeaderCard>
			<S.BodyCard>{bodyContent}</S.BodyCard>
		</S.Container>
	);
}

export default CardInfo;
